export default __webpack_public_path__ + "static/media/Odense Fjord.d9279076.xlsx";